import type { RoomState } from "../types";
import { PhaseTimer } from "./PhaseTimer";
import { PlayerAvatar } from "./PlayerAvatar";

interface Props {
  room: RoomState;
  you: string;
  onContinue: () => void;
}

export function Results({ room, you, onContinue }: Props) {
  const isHost = room.hostId === you;
  const sorted = [...room.drawings].sort((a, b) => b.votes.length - a.votes.length);
  const winnerId = room.lastWinnerId;
  const standings = [...room.players].sort((a, b) => b.score - a.score);

  return (
    <div className="results">
      <div className="results-head">
        <h2>Round {room.round} verdict</h2>
        <PhaseTimer endsAt={room.phaseEndsAt} label="Next round in" />
      </div>

      <div className="results-stage">
        <div className="results-grid">
          {sorted.map((d, idx) => {
            const drawer = room.players.find((p) => p.id === d.playerId);
            const isWinner = d.playerId === winnerId && d.votes.length > 0;
            return (
              <div key={d.playerId} className={`result-card ${isWinner ? "winner" : ""}`}>
                {isWinner && <div className="winner-banner">round winner</div>}
                <img src={d.image} alt={`drawing by ${drawer?.name ?? "?"}`} />
                <div className="result-meta">
                  <div className="result-author">
                    {drawer && <PlayerAvatar player={drawer} size={28} />}
                    <span>{drawer?.name ?? "?"}</span>
                  </div>
                  <div className="result-votes">
                    {d.votes.length} vote{d.votes.length === 1 ? "" : "s"} · +
                    {d.votes.length * 100 + (isWinner ? 50 : 0)}
                  </div>
                </div>
                <div className="result-rank muted small">#{idx + 1}</div>
              </div>
            );
          })}
        </div>

        <aside className="standings">
          <h3>Standings</h3>
          <ol>
            {standings.map((p, i) => (
              <li key={p.id}>
                <span className="standing-rank">{i + 1}</span>
                <PlayerAvatar player={p} size={28} />
                <span className="standing-name">{p.name}</span>
                <span className="standing-score">{p.score}</span>
              </li>
            ))}
          </ol>
          {isHost ? (
            <button className="primary big" onClick={onContinue}>
              {room.round >= room.totalRounds ? "Show final scores" : "Next round"}
            </button>
          ) : (
            <p className="muted small">Host moves the game forward.</p>
          )}
        </aside>
      </div>
    </div>
  );
}
